/* global axios */
import ApiClient from './ApiClient';

class AgentConsentsAPI extends ApiClient {
  constructor() {
    super('agent_consents', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  accept(purpose, metadata = {}, params = {}) {
    return axios.post(this.url, { purpose, metadata }, { params });
  }

  revoke(purpose, metadata = {}, params = {}) {
    return axios.delete(`${this.url}/${purpose}`, {
      data: { metadata },
      params,
    });
  }
}

export default new AgentConsentsAPI();
